export default {
    school: {
        info: "Informação Básica",
        record: "Consultar histórico de pagamento das taxas anuais dos recentes anos",
        record_title: "Histórico de pagamento das taxas anuais dos recentes anos",
        companyIdentityType: "Tipo do registo comercial",
        companyBrNo: "N.º do registo comercial",
        licenseNo: "N.º do licença da escola de condução",
        licenseNo_coach: "N.º do licença de instrutor ",
        licenseNo_headmaster: "N.º do licença de director de escola ",
        lastIssueDate: "Última data de emissão da carta de condução",
        lastIssueDate_coach_headmaster: "Data de emissão da licença",
        schoolName: "Nome da escola de condução",
        infoTips: 'Por actualização de dados, favor ligar para Área de Atendimento da DSAT.',
        payment_info: "Informação de pagamento",
        payment_name: "Descrição do item em pagamento",
        amount: "Taxa anual",
        taxAmount: "Imposto de selo(10% da taxa de pedido)",
        notice: "Notificação de pagamento",
        payment_notice: " (por EMAIL)",
        payment_btn: "Pagar agora",
        email: 'Correio electrónico (opcional): ',
        email_required: 'Correio electrónico: ',
        email_plh: 'Introduza o correio electrónico',
        email_again_plh: 'Introduza de novo o correio electrónico',
        taxYear: "Anual",
        spNo: "N.º de referência no recibo",
        totalAmount: "Montante total de pagamento",
        paymentType: "Forma de pagamento",
        paymentTime: "Data do pagamento",
        surname: 'Apelido',
        name: 'Nome',
        nextTrainYear: "Ano do próximo curso de  formação",
        schoolName_name: "Escola de Condução",
        lastUpdDate: "Data de serviço",
        CO: "Firma do empresário comercial, pessoa singular(CO)",
        EM: "Empresa comercial(EM)",
        SO: "Firma de empresário comercial, pessoa colectiva(SO)",
        ES: "駕駛學校(ES)",
        mobile_sms: "Telefone celular local (a agência enviará notificação por SMS após a conclusão do serviço)",
        school_identType: "Tipos de registro de empresas para autoescolas",
        school_identType_plc: "Selecione o tipo de registro comercial da escola de direção",
        school_identNo: "Número de registro comercial da escola de direção",
        school_choose: "Escolha qualquer identidade para o processamento comercial",
        school_identNo_plh: "Insira o número de registro comercial da escola de direção",
        school_licenseNo: "Número da licença da escola de condução",
        school_licenseNo_plh: "Insira o número da licença da escola de direção",
        sendSms_tips: "Concordo com o envio de SMS referente ao pagamento em simultâneo para o titular da licença ( no. de telm:{0})",
        terms_body_school: "<p>" +
            "  1. Indicações de utilização:" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li><span>1.1</span><span style='flex:1'>O pagamento efectuado através deste sistema é feito em patacas;</span></li>" +
            "  <li><span>1.2</span><span style='flex:1'>Após conclusão da transacção, o montante pago não é reembolsável;</span></li>" +
            "  <li><span>1.3</span><span style='flex:1'>Em caso de avaria do sistema informático ou de outra situação especial e, não obstante, ter efectuado o pagamento de qualquer importância que foi, indevidamente, recebido pelo Governo da RAEM, favor de contactar ou dirigir-se pessoalmente à DSAT, o mais rápido possível.</span></li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  2. Protecção dos dados pessoais" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li><span>2.1</span><span style='flex:1'>A Direcção dos Serviços para os Assuntos de Tráfego (DSAT), enquanto Serviço autor do website, garante o cumprimento das respectivas normas por parte dos seus trabalhadores e o tratamento dos dados pessoais está sujeito a medidas de sigilo. Os dados pessoais recolhidos serão conservados até perderem a utilidade de recolha ou até ao termo do prazo de conservação definido pelo Governo e posteriormente destruídos de acordo com disposição legal;</span></li>" +
            "  <li><span>2.2</span><span style='flex:1'>Os dados pessoais inseridos no presente website podem ser consultados ou alterados quando solicitados por si à DSAT ou a outros serviços que procederam à recolha e conservação dos dados.</span></li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  3. Declaração de exclusão de responsabilidade" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li><span>3.1</span><span style='flex:1'>O presente website procura assegurar a exactidão do conteúdo, não dando, porém, quaisquer garantias ou compromissos, explícitos ou implícitos. As informações nele contidos são fornecidos conforme “situação actual”. A DSAT reserva o direito de eliminar, em qualquer momento, as informações do presente website sem aviso prévio, bem como suspendê-las provisoriamente ou proceder à sua edição. A DSAT não assumirá qualquer responsabilidade nem compensação a quaisquer danos ou perdas resultantes da utilização das informações do website.</span></li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  4. Cláusulas de privacidade" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li><span>4.1</span><span style='flex:1'>Os dados pessoais inseridos pelo requerente no presente sistema serão exclusivos ao uso do sistema e imprimidos no recibo electrónico;</span></li>" +
            "  <li><span>4.2</span><span style='flex:1'>A DSAT utiliza a Secure Sockets Layer”(SSL) para garantir a confidencialidade dos dados pessoais dos utentes introduzidos no seu website.</span></li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  5. Caso existam actualizações às cláusulas de utilização, uma nova versão será publicada no lugar da antiga, não carecendo de qualquer anúncio sendo que a data da revisão estará devidamente assinalada na versão revista." +
            "  <br />" +
            "</p>" +
            "<p></p>" +
            "<p>" +
            "  6. Forma de contacto" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li>Endereço: Área de Atendimento da DSAT (Estrada de D. Maria II) situada na Estrada de D. Maria II, n.º 33, Macau</li>" +
            "  <li>Horário de expediente: de segunda a sexta-feira, das 9 da manhã às 6 da tarde (aberto durante a hora de almoço)</li>" +
            "  <li>Linha Aberta para os Assuntos de Tráfego: (853) 8866 6363</li>" +
            "  <li>Correio electrónico: info@dsat.gov.mo</li>" +
            "</ul>",
        terms_body_staff: "<p>" +
            "  1. Nota importante" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li><span>1.1</span><span style='flex:1'>Aos que não forem titulares de licença de modelo novo não poderão recorrer a este serviço;</span></li>" +
            "  <li><span>1.2</span><span style='flex:1'>Aos que não se candidataram ao curso de reciclagem dentro do prazo estipulado não poderão recorrer a este serviço.</span></li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  2. Indicações de utilização:" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li><span>2.1</span><span style='flex:1'>O pagamento efectuado através deste sistema é feito em patacas;</span></li>" +
            "  <li><span>2.2</span><span style='flex:1'>Após conclusão da transacção, o montante pago não é reembolsável;</span></li>" +
            "  <li><span>2.3</span><span style='flex:1'>Em caso de avaria do sistema informático ou de outra situação especial e, não obstante, ter efectuado o pagamento de qualquer importância que foi, indevidamente, recebido pelo Governo da RAEM, favor de contactar ou dirigir-se pessoalmente à DSAT, o mais rápido possível.</span></li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  3. Protecção dos dados pessoais" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li><span>3.1</span><span style='flex:1'>A Direcção dos Serviços para os Assuntos de Tráfego (DSAT), enquanto Serviço autor do website, garante o cumprimento das respectivas normas por parte dos seus trabalhadores e o tratamento dos dados pessoais está sujeito a medidas de sigilo. Os dados pessoais recolhidos serão conservados até perderem a utilidade de recolha ou até ao termo do prazo de conservação definido pelo Governo e posteriormente destruídos de acordo com disposição legal;</span></li>" +
            "  <li><span>3.2</span><span style='flex:1'>Os dados pessoais inseridos no presente website podem ser consultados ou alterados quando solicitados por si à DSAT ou a outros serviços que procederam à recolha e conservação dos dados.</span></li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  4. Declaração de exclusão de responsabilidade" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li><span>4.1</span><span style='flex:1'>O presente website procura assegurar a exactidão do conteúdo, não dando, porém, quaisquer garantias ou compromissos, explícitos ou implícitos. As informações nele contidos são fornecidos conforme “situação actual”. A DSAT reserva o direito de eliminar, em qualquer momento, as informações do presente website sem aviso prévio, bem como suspendê-las provisoriamente ou proceder à sua edição. A DSAT não assumirá qualquer responsabilidade nem compensação a quaisquer danos ou perdas resultantes da utilização das informações do website.</span></li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  5. Cláusulas de privacidade" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li><span>5.1</span><span style='flex:1'>Os dados pessoais inseridos pelo requerente no presente sistema serão exclusivos ao uso do sistema e imprimidos no recibo electrónico;</span></li>" +
            "  <li><span>5.2</span><span style='flex:1'>A DSAT utiliza a Secure Sockets Layer”(SSL) para garantir a confidencialidade dos dados pessoais dos utentes introduzidos no seu website.</span></li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  6. Caso existam actualizações às cláusulas de utilização, uma nova versão será publicada no lugar da antiga, não carecendo de qualquer anúncio sendo que a data da revisão estará devidamente assinalada na versão revista." +
            "  <br />" +
            "</p>" +
            "<p></p>" +
            "<p>" +
            "  7. Forma de contacto" +
            "  <br />" +
            "</p>" +
            "<ul class='terms-ul-inline'>" +
            "  <li>Endereço: Área de Atendimento da DSAT (Estrada de D. Maria II) situada na Estrada de D. Maria II, n.º 33, Macau</li>" +
            "  <li>Horário de expediente: de segunda a sexta-feira, das 9 da manhã às 6 da tarde (aberto durante a hora de almoço)</li>" +
            "  <li>Linha Aberta para os Assuntos de Tráfego: (853) 8866 6363</li>" +
            "  <li>Correio electrónico: info@dsat.gov.mo</li>" +
            "</ul>",
    }
}